// import fs from 'fs';
export * from './gateway'
export * from './label'
export * from './products'
export * from './record'
export * from './authorization'
export * from './settings'
// export * from './products'
export * from './shops'
export * from './templates'
export * from './template'
export * from './system'
export * from './login'
export * from './overview'
export * from './common'
export * from './Header'
export * from './shop'
export * from './personInfo'
export * from './Home'
export * from './errorCode'
export * from './import'

// const api = fs.readdirSync(__dirname).filter((value) => {
//     return value !== 'index.js';//过滤自身
// }).map(value => require('./' + value));

// export default api;


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/index.js